<template>
  <div class="cabinet-page" :class="{ 'is-loading': loading }">
    <button class="request-detail__back" type="button" @click="$router.back()">‹ {{ $t('common.back') }}</button>
    <cabinet-page-header :title="$t('requests.detailTitle')" :subtitle="$t('requests.detailSubtitle')" />
    <app-page-loader v-if="loading" />
    <cabinet-state v-else-if="loadError" type="error" :title="$t('requests.unavailableOne')" @retry="loadDetail" />
    <article v-else class="request-detail">
      <div class="request-detail__header"><h2>{{ title }}</h2><cabinet-status :status="detail.status" /></div>
      <dl><template v-for="row in rows"><dt :key="`${row.label}-label`">{{ row.label }}</dt><dd :key="row.label">{{ row.value }}</dd></template></dl>
    </article>
  </div>
</template>

<script>
import { getPersonalCabinetSourceDetail } from '@/http'
import { formatLocalizedDate } from '@/i18n'
import CabinetPageHeader from './CabinetPageHeader'
import CabinetState from './CabinetState'
import CabinetStatus from './CabinetStatus'

export default {
  name: 'PersonalCabinetRequestDetail',
  components: { CabinetPageHeader, CabinetState, CabinetStatus },
  data() { return { loading: true, loadError: false, detail: {} } },
  computed: {
    source() { return this.$route.query.source },
    title() { return this.detail.type ? this.$choice('leaveTypes', this.detail.type) : (this.detail.category ? this.$choice('categories', this.detail.category) : this.$choice('sources', this.source, this.$t('requests.request'))) },
    rows() {
      const ignored = ['id', 'status', 'type', 'category', 'proof']
      return Object.entries(this.detail).filter(([key, value]) => !ignored.includes(key) && value !== null && value !== '' && typeof value !== 'object')
        .map(([key, value]) => ({
          label: this.$t(`fields.${key}`, {}, key.replace(/_/g, ' ').replace(/^./, char => char.toUpperCase())),
          value: this.formatValue(key, value),
        }))
    },
  },
  created() { this.loadDetail() },
  methods: {
    formatValue(key, value) {
      if (typeof value === 'boolean') return this.$t(value ? 'common.yes' : 'common.no')
      if (typeof value !== 'string') return value
      if (/_at$/.test(key)) return formatLocalizedDate(value, { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
      if (/_month$/.test(key)) return formatLocalizedDate(value, { month: 'long', year: 'numeric' })
      if (/_date$/.test(key)) return formatLocalizedDate(value, { day: '2-digit', month: 'short', year: 'numeric' })
      return value
    },
    loadDetail() {
      this.loading = true
      this.loadError = false
      return getPersonalCabinetSourceDetail(this.source, this.$route.query.sourceId)
        .then(({ data }) => { this.detail = data })
        .catch(() => { this.loadError = true })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="sass" scoped>
.request-detail__back
  margin-bottom: 15px
  color: #897b33
  font-size: 13px
  font-weight: 600
.request-detail
  padding: 20px
  border: 1px solid #e7e1d5
  border-radius: 20px
  background: #fffefa
.request-detail__header
  display: flex
  align-items: flex-start
  justify-content: space-between
  gap: 14px
  padding-bottom: 16px
  border-bottom: 1px solid #ebe6dc
  h2
    font-family: 'Mazzard Soft H', 'SFUIText', sans-serif
    font-size: 21px
    font-weight: 600
    line-height: 1.25
    letter-spacing: -.2px
.request-detail dl
  display: grid
  grid-template-columns: 42% 1fr
  gap: 0
  margin-top: 8px
  dt, dd
    padding: 11px 0
    border-bottom: 1px solid #f0ece4
    font-size: 12px
    line-height: 1.4
  dt
    color: #929087
  dd
    margin: 0
    color: #383931
    overflow-wrap: anywhere
</style>
